import React, { useContext, useEffect, useState } from "react";
import { SettingsContext, ShopContext, CartContext, CategoriesContext } from "../App";
import Products from "./Products";
import Footer from "./Footer";
import Header from "./Header";
import Menu from "./Menu";
import Categories from "./Categories";
import Courses from "./Courses";
import ProductsOnePage from "./ProductsOnePage";
import Responsive from "./Responsive.js";
import Label from "./Label.js";
import CategoriesTags from "./CategoriesTags.js";
import { textLabel } from "./functions/functions.js";
import SearchIcon from "../icons/SearchIcon.jsx";
import CloseIcon from "../icons/CloseIcon.jsx";
import CheckIcon from "../icons/CheckIcon.jsx";

function Page() {
  const { settings, course, category, initTablePayment, labels, lang, setCategoryHandler } =
    useContext(SettingsContext);
  const { shop, brand } = useContext(ShopContext);
  const { categories } = useContext(CategoriesContext);
  const { cart } = useContext(CartContext);
  const [menuVisible, setMenuVisible] = useState(false);
  const [src, setSrc] = useState("");
  const [srcProducts, setSrcProducts] = useState([]);
  const [courseDropdownOpen, setCourseDropdownOpen] = useState(false);

  useEffect(() => {
    filter();
  }, [src]);

  function filter() {
    console.log("filter");
    let arr = [];
    if (src) {
      categories.map((course) =>
        course.categories.map((category) =>
          category.products.map((product) => {
            //console.log(product.name, src, product.name.includes(src));
            if (product.name.toLowerCase().includes(src.toLowerCase())) arr.push(product);
          }),
        ),
      );
    }
    arr.sort(function (a, b) {
      return a["name"] > b["name"] ? 1 : -1;
    });
    setSrcProducts(arr);
  }

  return (
    <>
      <div className="page">
        <Header menuVisible={menuVisible} setMenuVisible={setMenuVisible} />
        {settings.selfordering.categories_menu_type == 2 && course && (
          <div className="menu-categories-2">
            {courseDropdownOpen && (
              <div className="macro-course-backdrop" onClick={() => setCourseDropdownOpen(false)} />
            )}
            {categories.length > 1 && courseDropdownOpen && (
              <div className="macro-course-dropdown">
                {categories.map((cr, i) => (
                  <button
                    key={i}
                    className={"item" + (course && cr.id == course.id ? " active" : "")}
                    onClick={() => {
                      setCategoryHandler(cr, cr.categories[0]);
                      setCourseDropdownOpen(false);
                    }}
                  >
                    <span>{String(cr.name || "").trim() || "Altro"}</span>
                    {course && cr.id == course.id && <CheckIcon />}
                  </button>
                ))}
              </div>
            )}
            <div className="scroll-content">
              {categories.length > 1 && (
                <button
                  className={"button macro-course-selector" + (courseDropdownOpen ? " open" : "")}
                  onClick={() => setCourseDropdownOpen(!courseDropdownOpen)}
                >
                  <span>{course ? String(course.name || "").trim() || "Altro" : ""}</span>
                  <span className="macro-course-chevron">{courseDropdownOpen ? "▴" : "▾"}</span>
                </button>
              )}
              {categories &&
                (categories.length > 1
                  ? (course ? course.categories : []).map((c) => ({ cr: course, c }))
                  : categories.flatMap((cr) => cr.categories.map((c) => ({ cr, c })))
                ).map(({ cr, c }, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      setCategoryHandler(cr, c);
                    }}
                    className={"button " + (c.id == category.id ? "active" : "")}
                  >
                    {c.name}
                    <CategoriesTags category={c} />
                  </button>
                ))}
            </div>
          </div>
        )}
        <div className="lock-content">
          <div className="columns">
            {settings.selfordering.categories_menu_type == 3 && (
              <div className="sidebar">
                {categories.map((course, i) => (
                  <div key={i}>
                    <div className="course-title">{String(course.name || "").trim() || "Altro"}</div>
                    {course.categories.map((c, n) => (
                      <button
                        className={category.id == c.id ? "selected" : ""}
                        key={n}
                        onClick={() => {
                          setCategoryHandler(course, c);
                        }}
                      >
                        <CategoriesTags category={c} />
                        {c.name}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            )}
            <div className={"main " + (settings.selfordering.categories_menu_type == 2 ? "d-block" : "")}>
              <div className="inner-container">
                <div className="src">
                  <span>
                    <SearchIcon></SearchIcon>
                  </span>
                  <input
                    type="text"
                    value={src}
                    onChange={(e) => setSrc(e.target.value)}
                    placeholder={textLabel(labels, 134, lang)}
                  />
                  {src && (
                    <button onClick={() => setSrc("")}>
                      <CloseIcon></CloseIcon>
                    </button>
                  )}
                </div>
                <div id="main" className="inner-content">
                  {src && <Products src={srcProducts} />}
                  {!src && !course && <Courses />}
                  {course && !category && <Categories />}
                  {!src && course && category && settings.selfordering.products_loading_type == "onepage" && (
                    <ProductsOnePage />
                  )}
                  {!src && course && category && settings.selfordering.products_loading_type != "onepage" && (
                    <Products />
                  )}
                </div>
              </div>
            </div>
          </div>
          {cart && cart.closures?.closed == 1 && (
            <div className="internal-lock">
              <div className="internal-lock-content">
                <div className="message">{cart.closures?.message}</div>
                {shop.selfordering_show_menu == 1 && (!brand || settings.selfordering.show_menu == 1) && (
                  <a
                    href={settings.menu?.url + "?shop_id=" + shop.id + (brand ? "&brand_id=" + brand.id : "")}
                    target="_blank"
                    rel="noreferrer"
                    className="button"
                  >
                    Sfoglia il menu
                  </a>
                )}
              </div>
            </div>
          )}
          {cart && cart.is_lock == 1 && (
            <div className="internal-lock">
              <div className="internal-lock-content">
                <div className="title">
                  <Label number={123} />
                </div>
                <div className="message">
                  <Label number={124} />
                </div>
                <button onClick={initTablePayment}>
                  <Label number={125} />
                </button>
              </div>
            </div>
          )}
        </div>
        {cart && <Footer />}
        <Responsive />
      </div>
      {menuVisible && <Menu setMenuVisible={setMenuVisible} />}
    </>
  );
}

export default Page;
